import React, { useCallback } from 'react';
import './token-redemption-sign-pay-details.scss';
import {TokenRedemptionDocumentType, TokenRedemptionType} from 'constants/redemption';
import TokenRedemptionParams from '../TokenRedemptionParams';
import { LoadDocBtn } from '@ru-digital-assets/ui-component';
import { getFormatedDate } from 'utils';
import Step from 'modules/step';
import { useSelector, useDispatch } from 'hooks/redux';
import { downloadFile } from 'utils/files/downloadFile';
import { setPush } from 'store/actions/app';
import RedemptionApi from 'services/api/RedemptionApi';
import { useHistory } from 'react-router';
import { showLoader, hideLoader } from 'store/actions/loader';
import { BlockchainTransactionInfo, TokenStatusBadge } from 'components';

interface ITokenRedemptionSignPayDetails {
  redemptionType: TokenRedemptionType;
  asset: any;
}

export default function TokenRedemptionSignPayDetails({
  redemptionType,
  asset,
}: ITokenRedemptionSignPayDetails) {
  const dispatch = useDispatch();
  const history = useHistory();
  const token = useSelector((state) => state.auth.account.token);
  const assetId = history.location.state.id;

  const downloadPaymentDoc = useCallback((name: string, mimeType: string) => {
    dispatch(showLoader());
    RedemptionApi.getRedeemPaymentDocument(token, assetId)
      .then((response) => {
        downloadFile(response.data, name, mimeType);
      })
      .catch(() => {
        dispatch(
          setPush({
            message: 'Ошибка при загрузке документа',
            type: 'error',
          })
        );
      })
      .finally(() => {
        dispatch(hideLoader());
      });
  }, []);

  const downloadNotifyDoc = useCallback((name: string, mimeType: string) => {
    dispatch(showLoader());
    RedemptionApi.getRedeemDocument(token, assetId, TokenRedemptionDocumentType.NOTIFY_REDEEM_DOC)
      .then((response) => {
        downloadFile(response.data, name, mimeType);
      })
      .catch(() => {
        dispatch(
          setPush({
            message: 'Ошибка при загрузке документа',
            type: 'error',
          })
        );
      })
      .finally(() => {
        dispatch(hideLoader());
      });
  }, []);

  return (
    <div className="token-redemption-sign-pay-details">
      <div className="token-redemption-sign-pay-details__left">
        <div className="mb_32">
          <Step
            steps={[
              { title: 'Инициация погашения' },
              { title: 'Оплата', active: true },
              { title: 'Подтверждение погашения' },
            ]}
          />
        </div>
        <p className="p p_font-size_24 p_font-weight_light mb_16">
          Погашение {asset.actualCount} токенов
          <br />
          {asset.issuingInfo.tokenName}
        </p>
        <div className="mb_16">
          <TokenStatusBadge
            text="Требуется подтвердить оплату"
            variant="yellow"
          />
        </div>
        <p className="p p_bold mb_24">Документы для погашения:</p>
        <div className="mb_16">
          <LoadDocBtn
            title="Документ подтверждающий факт оплаты"
            extension=".PDF"
            onSpecDownload={() =>
              downloadPaymentDoc(
                'Документ подтверждающий факт оплаты',
                'application/pdf'
              )
            }
          />
        </div>
        <LoadDocBtn
          title={
            redemptionType === TokenRedemptionType.execution
              ? 'Уведомление об исполнении обязательств'
              : 'Заявление о прекращении обязательств'
          }
          extension=".PDF"
          onSpecDownload={() =>
            downloadNotifyDoc(
              redemptionType === TokenRedemptionType.execution
                ? 'Уведомление об исполнении обязательств'
                : 'Заявление о прекращении обязательств',
              'application/pdf'
            )
          }
        />
      </div>
      <div className="token-redemption-sign-pay-details__right">
        <p className="p p_bold mb_24">Параметры погашения</p>
        <p className="p p_font-size_12 p_color_light-grey">ID транзакции</p>
        <div className="mb_32">
          <BlockchainTransactionInfo hash={asset.blockchainTransactionId} />
        </div>
        <TokenRedemptionParams redemptionType={redemptionType} asset={asset} />
        <p className="p p_font-size_12 p_color_light-grey mt_12">
          Дата исполнения обязательств
        </p>
        <p className="p mb_12">
          {getFormatedDate(asset.issuingInfo.finalizedDate, 'dd MMMM yyyy')}
        </p>
      </div>
    </div>
  );
}
